const __WEBPACK_NAMESPACE_OBJECT__ = require("@fortawesome/free-solid-svg-icons");